'use client';

import { Link } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

const StickyButton = () => {
  const t = useTranslations('common.buttons');
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.innerWidth >= 768) return;

    const handleScroll = () => {
      const videosEl = document.getElementById('videos');
      const footerEl = document.querySelector('footer');

      if (!videosEl) return;

      const videosRect = videosEl.getBoundingClientRect();
      const screenCenter = window.innerHeight / 2;

      let footerVisible = false;
      if (footerEl) {
        const footerRect = footerEl.getBoundingClientRect();
        footerVisible = footerRect.top < window.innerHeight;
      }

      const shouldShow = videosRect.top < screenCenter && !footerVisible;
      setShowButton(shouldShow);
    };

    const addScrollListener = () => {
      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    };

    if (document.readyState === 'complete') {
      addScrollListener();
    } else {
      window.addEventListener('load', addScrollListener);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('load', addScrollListener);
    };
  }, []);

  useEffect(() => {
    let positionTimeout;

    const adjustOpenWidgetPosition = () => {
      clearTimeout(positionTimeout);

      positionTimeout = setTimeout(() => {
        const openWidgetLauncher = document.querySelector('[data-openwidget-launcher]') ||
          document.querySelector('.openwidget-launcher') ||
          document.querySelector('#chat-widget-container') ||
          document.querySelector('[class*="openwidget"]');

        if (openWidgetLauncher) {
          openWidgetLauncher.style.bottom = showButton ? '75px' : '20px';
          openWidgetLauncher.style.transition = 'bottom 0.3s ease';
        } else {
          setTimeout(adjustOpenWidgetPosition, 200);
        }
      }, 150);
    };

    adjustOpenWidgetPosition();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          const hasOpenWidget = addedNodes.some(node =>
            node.nodeType === 1 &&
            (node.hasAttribute?.('data-openwidget-launcher') ||
              node.classList?.toString()?.includes('openwidget') ||
              node.querySelector?.('[data-openwidget-launcher]') ||
              node.querySelector?.('[class*="openwidget"]') ||
              (typeof node.id === 'string' && node.id.includes('openwidget')))
          );

          if (hasOpenWidget) {
            setTimeout(adjustOpenWidgetPosition, 100);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      clearTimeout(positionTimeout);
      observer.disconnect();
    };
  }, [showButton]);

  return (
    <>
      {showButton && (
        <div className="fixed bottom-0 md:hidden left-0 z-50 h-[80px] flex justify-center items-center w-full bg-white shadow-[0_-1px_4px_1px_rgba(0,0,0,0.14)]">
          <div className="flex flex-col md:mt-8">
            <Link
              href="/create-your-book"
              className="w-[240px] h-[50px] mx-auto flex justify-center items-center bg-orange text-white font-semibold text-[21px] rounded-[10.3px] gap-2 shadow-heroBtnShadow group btn-primary"
            >
              <span className="mb-[2px]">{t('createYourBook')}</span>
              <span className="transform group-hover:translate-x-1.5 transition">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.38281 1.47266L10.8996 6.14064C11.0199 6.2649 11.0202 6.46204 10.9004 6.58672L6.38281 11.2879" stroke="white" strokeWidth="2.04485" strokeLinecap="round" />
                  <path d="M1.48438 1.47266L6.00119 6.14064C6.12143 6.2649 6.12177 6.46204 6.00196 6.58672L1.48438 11.2879" stroke="white" strokeWidth="2.04485" strokeLinecap="round" />
                </svg>
              </span>
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default StickyButton;